import { render, staticRenderFns } from "./ProductVersionSelect.vue?vue&type=template&id=5564d40d"
import script from "./ProductVersionSelect.vue?vue&type=script&lang=js"
export * from "./ProductVersionSelect.vue?vue&type=script&lang=js"
import style0 from "./ProductVersionSelect.vue?vue&type=style&index=0&id=5564d40d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports